import React from 'react'
import '../css/condiciones.css'
import Footer from '../components/Footer'
import { useTranslation } from 'react-i18next';
export default function Condiciones() {
    const { t } = useTranslation('condiciones');
  return (
    <>
        <section>
            <div className='header_section'>
                <div className='container header_section_box'>
                    <div className='header_section_title'>
                        <h3>{t('condiciones')} </h3>
                        <p></p>
                    </div>                
                </div>
            </div>
        </section>
    
    <section className='condiciones_servicios'>
        <div className='container'>
            <div>
                <h3>1.{t('text1')}</h3>
                <p>{t('text2')}</p>
            </div>
            <div>
                <h3>2.{t('text3')}</h3>
                <p>{t('text4')}</p>
                <p>{t('text5')}</p>
                <p>{t('text6')}</p>

                <p>{t('text7')}</p>
                <p>1.{t('text8')}. {t('text9')}.</p>

                <p>{t('text10')}</p>

                <p>{t('text11')}:  {t('text12')}</p>

                <p>{t('text13')}</p>
                <p>{t('text14')}</p>

                <p>{t('text15')}</p>

                <p>{t('text16')}: {t('text17')} </p>
                <p>2.{t('text18')}: {t('la_empresa')}  {t('text19')} </p>

                <p>{t('text20')}</p>

                <p>{t('text21')} {t('la_empresa')} {t('text22')}.</p>

                <p>{t('text24')}</p>

                <p>{t('text25')}  {t('la_empresa')}{t('text26')} </p>

                <p>{t('text27')}</p>

                <p>{t('text28')} {t('la_empresa')}.</p>

                <p>{t('text29')}</p>

                <p>{t('text30')}</p>

                <p>i) {t('la_empresa')}, {t('text31')} {t('la_empresa')} {t('text32')}</p>
                
                <p>{t('text33')} </p>
                <p>{t('text34')} {t('text35')}{t('text36')}  </p>

                <p>3. {t('text37')} {t('text38')}: </p>

                <p>I.- {t('text39')} </p>

                <p>II.- {t('text40')}</p>

                <p>{t('text41')} {t('la_empresa')} {t('text42')} {t('cliente')}, {t('text43')}:</p>

                <p>I.- {t('text44')}</p>
                <p>II.- {t('text45')} </p>

                <p>{t('text46')}</p>

                <p>{t('text47')}</p>

                <p>4. {t('text48')}: {t('text49')}</p>

                <p>{t('text50')} </p>

                <p>5. {t('text51')}, {t('text52')}:</p>

                <p>{t('text53')}a) .</p>

                <p>{t('text54')}b) </p>

                <p>{t('text55')} {t('la_empresa')} {t('text56')}</p>

                <p>{t('text57')}d) . </p>

                <p>6. {t('la_empresa')} {t('text58')}. </p>

                <p> {t('text59')} {t('text60')} {t('la_empresa')}. {t('la_empresa')} {t('text61')}  </p>

                <p>{t('text62')}</p>

                <p>8. {t('text63')}.</p>
                <p>{t('text64')}A) : {t('text65')}, {t('cliente')} {t('text66')} {t('pasajero')}  {t('text67')}: </p>

                <p>{t('text68')}  {t('text69')}: </p>

                <p>i {t('text70')} </p>

                <p>ii  {t('text71')}</p>

                <p>iii {t('text72')} </p>

                <p>{t('text73')}</p>

                <p>{t('text74')}</p>

                <p>{t('text75')}</p>

                <p>{t('text76')}</p>

                <p>{t('text77')}</p>

                <p>{t('text78')}</p>

                <p>{t('text79')}</p>

                <p>{t('text80')}</p>
                <p>{t('text81')}</p>
                <p>{t('text82')}</p>
                <p>{t('text83')}</p>

                <p>{t('text84')}</p>

                <p>{t('text85')}</p>

                <p>{t('text86')}</p>

                <p>{t('text87')}: {t('text88')}</p>

                <p>{t('text89')} {t('pasajero')} {t('text90')} </p>

                <p>{t('text91')} </p>
                <p>{t('text92')}</p>

                <p>{t('text93')}{t('text94')}.- {t('la_empresa')} {t('text95')} </p>

                <p>9. {t('text96')}{t('pasajero')} {t('text97')}: </p>

                <p>{t('text98')}</p>
                <p>{t('text99')}</p>
                <p>{t('text100')}</p> 
                <p>{t('text101')} </p>

                <p>10. {t('text102')} {t('text103')} {t('la_empresa')} {t('text105')} </p>

                <p>{t('la_empresa')} {t('text105')}  {t('la_empresa')}{t('text106')} {t('pasajero')} {t('text107')} </p>
                <p>{t('text108')} {t('pasajero')} {t('text109')}</p>

                <p>{t('text110')}:{t('text111')} </p>

                <p>{t('text112')}:{t('text113')}</p>

                <p>{t('text114')}:</p>
                <p>{t('text115')}: {t('text116')}  </p>

                <p>{t('text117')}: {t('text118')} </p>

                <p>{t('text119')}: {t('text120')}. </p>

                <p>{t('text121')}: {t('text122')}. </p>
                <p>{t('text123')} {t('text124')}. </p>

                <p>11. {t('text125')}.  {t('la_empresa')} {t('text126')} </p>

                <p>{t('text127')} </p>

                <p>12. {t('text128')}. {t('text129')}  {t('la_empresa')}{t('text130')}</p>

                <p>13. {t('text131')}{t('text132')}  {t('la_empresa')}, {t('texto2')}  {t('la_empresa')}.</p>

                <p>14. {t('text133')} {t('text134')}  </p>

                <p>15. {t('text135')} . {t('text136')} </p>

                <p>16. {t('text137')}. {t('text138')} {t('la_empresa')},{t('text139')}  </p>

                <p>17. {t('text140')}. {t('text141')} </p>

                <p>18. {t('text142')}.  {t('text143')}  {t('la_empresa')} {t('text144')} </p>

                <p>19. {t('text145')}{t('text146')}</p>
            </div>

        </div>
    </section>
    <Footer />
    </>
  )
}

